import {
    defineStore,
} from "pinia";
import _ from "lodash";
import {
    HsabEnrollmentState,
    FetchState,
    HsabEnrollmentSettingsResponse,
    HsabEnrollmentSettingsUpdateRequest
} from "@/shared/types";
import * as bankService from "@/shared/api/bankService";
import * as userService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { useNotifierStore } from "@/shared/store/notifier";
const initialState: HsabEnrollmentState = {
    settingsFetchState: FetchState.Uninitialized,
    settings: null,
};

export const useHsabEnrollmentStore = defineStore("hsabEnrollment", {
    state: (): HsabEnrollmentState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded (): boolean {
            return this.settingsFetchState === FetchState.Loaded;
        }
    },
    actions: {
        setHsabEnrollmentSettingsLoaded () {
            this.settingsFetchState = FetchState.Loaded;
        },
        setHsabEnrollmentSettingsData (data: HsabEnrollmentSettingsResponse) {
            this.settings = data;
        },
        settingsSavedSuccessfully (settings: HsabEnrollmentSettingsUpdateRequest) {
          this.setHsabEnrollmentSettingsData(settings);
          const notifierStore = useNotifierStore();
          notifierStore.setSuccess("Enrollment Settings saved successfully. It may take a few minutes for this to update.");
        },
        async loadHsabEnrollmentSettings () {
            if (this.hsabEnrollmentSettingsState === FetchState.Loaded) {
                return Promise.resolve();
            }
            return userService.getHsabEnrollmentSettings()
                .then(r => this.setHsabEnrollmentSettingsData(r.data))
                .catch(e => {
                    this.settingsFetchState = FetchState.Failed;
                    return storeHelper.handleError({ error: e, rethrow: false });
                })
                .finally(() => this.setHsabEnrollmentSettingsLoaded());
        },
        async saveHsabEnrollmentSettings (settings: HsabEnrollmentSettingsUpdateRequest) {
            return bankService.updateHsabEnrollmentSettings(settings).catch(e => storeHelper.handleError({ error: e, rethrow: false }));
        }
    }
});